import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {LoadRolesAction, LoadRolesServerErrorAction, LoadRolesSuccessAction, userContextActionTypes} from '../actions/user-context';
import {ArrayResponse} from '../models/array-response';
import {Role} from '../models/role';
import {SendBackResult} from '../models/send-back-result';
import {UserContextService} from '../services/user-context.service';
import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class UserContextRolesEffect extends BaseEffect {

  load$ = createEffect(() => { return  this.actions$
      .pipe(ofType(userContextActionTypes.LOAD_ROLES),
        debug('Load roles action received'),
        map((action: LoadRolesAction) => action.payload),
        switchMap((clientId: string) => this.userContextService.loadRoles(clientId)
          .pipe(
            map((payload: SendBackResult<ArrayResponse<Role>>) => new LoadRolesSuccessAction(payload.data.array)),
            catchError(res => this.catchResponseError(res)),
          )))
  });


  loadFail$ = createEffect(() => { return this.actions$
                .pipe(ofType(userContextActionTypes.LOAD_ROLES_FAIL),
                  debug('A server error occurred while retrieving roles.'),
                  map((action: LoadRolesServerErrorAction) =>
                    error(this.translation.translate('USER_CONTEXT_GET_ROLES_ERROR') + '  ' + action.payload,
                      this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private userContextService: UserContextService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => new LoadRolesServerErrorAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadRolesServerErrorAction(response['error'].message);
  }
}
